module.exports = __webpack_public_path__ + "static/media/md.522c10de.png";